var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBenchmarking = function SvgBenchmarking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.4845 5.85417 1.6966.15398c.3084.02566.4311.42894.1963.64158l-1.2865 1.16585.3856 1.7341c.0701.31529-.2559.56462-.5223.39595l-1.4547-.92022-1.4547.91655c-.2664.16864-.5924-.08066-.5223-.39595l.3856-1.73043-1.28648-1.16585c-.23486-.21264-.10867-.61592.1998-.64158l1.69308-.15031.6625-1.63512c.1192-.29696.5258-.29696.645 0zm-.9845 6.14583c-.8284 0-1.5.6716-1.5 1.5v5c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5v-5c0-.8284-.6716-1.5-1.5-1.5zm-7.5-.5c0-.8284.67157-1.5 1.5-1.5s1.5.6716 1.5 1.5v7c0 .8284-.67157 1.5-1.5 1.5s-1.5-.6716-1.5-1.5zm13.5-7.5c-.8284 0-1.5.67157-1.5 1.5v13c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5v-13c0-.82843-.6716-1.5-1.5-1.5z",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBenchmarking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/benchmarking.c6c9de54.svg";
export { ForwardRef as ReactComponent };